import moment from "jalali-moment";
import Link from "next/link";
import {withRouter} from "next/router";
import React from "react";
import styled from "styled-components";

import {device} from "../../constants/media";
import t from "../../utils/locale";

const Container = styled.div`
  @media ${device.below.tablet} {
    flex-direction: column;
    margin: 0;
  }

  flex-direction: row;
  margin-top: 40px;
  display: flex;
  min-height: 250px;
`;

const CoverContainer = styled.div`
  @media ${device.below.tablet} {
    margin: 0.5rem 0;
    width: 100%;
  }

  margin: 0 0.5rem;
  width: ${props => (props.single ? "500px" : "300px")};
  overflow: hidden;
`;

const Cover = styled.img`
  margin: auto;
  width: 100%;
`;

const InfoContainer = styled.div`
  @media ${device.below.tablet} {
    margin: 0.5rem 0;
  }

  margin: 0 0.5rem;
  flex: 1;
  border-top: solid 3px #000;
  position: relative;
`;

const Date = styled.span`
  font-size: 15px;
  color: #888;
  margin-top: 10px;
`;

const Title = styled.h3`
  font-size: 20px;
  color: #333;
  margin-top: 10px;
`;

const Source = styled.div`
  display: flex;
  flex-direction: row-reverse;

  a {
    font-size: 0.75rem;
    text-decoration: inherit;
    color: #bbb;

    &:hover {
      color: #39c;
      border-bottom: solid 1px #39c;
    }

    &:focus {
      color: #25a;
      border-bottom: solid 1px #25a;
    }
  }
`;

const ReadMore = styled.div`
  @media ${device.below.tablet} {
    margin-bottom: 3rem;
  }

  a {
    font-size: 0.75rem;
    text-decoration: inherit;
    color: #b3b3b3;

    &:hover {
      color: #39c;
      border-bottom: solid 1px #39c;
    }

    &:focus {
      color: #25a;
      border-bottom: solid 1px #25a;
    }
  }
`;

const Header = styled.h3`
  transition: all 0.7s ease-in;
  font-size: ${props => (props.open ? "1.2em" : "1rem")};
`;

class NewsItem extends React.Component {
  getContent() {
    if (!this.props.single) {
      return this.props.post.text.substring(0, 240) + " ...";
    }

    return this.props.post.text;
  }

  render() {
    const post = this.props.post;
    const current_language = this.props.router.locale;
    const m = moment(post.created_at, "YYYY-M-D");

    return (
      <Container>
        <CoverContainer single={this.props.single}>
          <Cover src={post.cover} />
        </CoverContainer>

        <InfoContainer>
          <Date>{m.locale(current_language).format("YYYY/MM/DD")}</Date>

          <Title>{post.title}</Title>

          <div dangerouslySetInnerHTML={{__html: this.getContent()}} />

          {this.props.single && (
            <Source>
              <Link href={post.source}>{t(current_language, "Source")}</Link>
            </Source>
          )}

          {this.props.single && this.props.post.works.length > 0 && (
            <>
              <Header>{t(current_language, "Works")}</Header>
              {this.props.post.works.map(work => (
                <>
                  <Link key={work.id} prefetch={false} href={`/works/${work.slug}`}>
                    {work.title}
                  </Link>
                  <br />
                </>
              ))}
              <br />
            </>
          )}

          {!this.props.single && (
            <ReadMore>
              <Link href={"/news/" + post.slug}>
                {t(current_language, "Read more") + " . . . "}
              </Link>
            </ReadMore>
          )}
        </InfoContainer>
      </Container>
    );
  }
}

export default withRouter(NewsItem);
